export default {
  header: {
    hideMenuBar: 'Ocultar barra de menu',
    showMenuBar: 'Exibir barra de menu'
  }
}
